/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';
import { startCase, capitalize } from 'lodash';

const ListGroupItemCrisisIntervention = ({ data }) => {
  const detailObject = data.attributes.detailObject
    ? JSON.parse(data.attributes.detailObject)
    : data.attributes.detail
      ? data.attributes.detail
      : {};

  return (
    <span className="ml-2">
      {capitalize(startCase(detailObject.crisis))}
    </span>
  );
};

ListGroupItemCrisisIntervention.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ListGroupItemCrisisIntervention;
